import StampAppointment from "components/home/StampAppointment";
import TargetIndustries from "components/home/TargetIndustries";

import { STATUS_PROCESS } from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import { get } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  getListSmartForm,
  selectListSmartForm,
  setSmartServiceId
} from "redux/modules/visaForm";

function InformationTab() {
  const dispatch = useDispatch();
  const listSmartFormState = useSelector(selectListSmartForm);
  const hasCreatedSmartForm = listSmartFormState.data.length;
  const { personalID } = useSelector((state) => state.personal.detail);
  const hasSmartFormComplete = listSmartFormState.data.some(
    (v) => v.statusDocName === "Completed"
  );
  const hasSmartFormDraft = listSmartFormState.data.some(
    (v) => v.statusDocName === "Draft"
  );
  const smartFormDraft = listSmartFormState.data.filter(
    (v) => v.statusDocName === "Draft"
  );
  const shouldShowContinue = hasCreatedSmartForm && hasSmartFormDraft;
  const shouldShowVisaType = !hasCreatedSmartForm;
  const smartserviceId = get(smartFormDraft, "0.smartserviceId", "");

  useEffect(() => {
    dispatch(getListSmartForm());
  }, [personalID]);

  let datalist = [];

  if (listSmartFormState?.data?.length > 0) {
    datalist = listSmartFormState?.data
      .filter((x) => x.visaStartDate)
      .sort(
        (a, b) =>
          new Date(b.visaStartDate).getTime() -
          new Date(a.visaStartDate).getTime()
      );
  }

  const docDetail = datalist?.find(
    (x) =>
      x.statusProcessId === STATUS_PROCESS.FinalApproved ||
      x.statusProcessId === STATUS_PROCESS.VisaIssuance ||
      x.statusProcessId === STATUS_PROCESS.VisaReceived ||
      x.statusProcessId === STATUS_PROCESS.FinalApprovedNew ||
      x.statusProcessId === STATUS_PROCESS.Appointment
    // x.statusProcessId === STATUS_PROCESS.Complete
  );

  const handleClickContinue = () => {
    if (smartserviceId) {
      dispatch(setSmartServiceId(smartserviceId));
      dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
      dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
    }
  };

  return (
    <div>
      {docDetail && <StampAppointment data={docDetail} />}

      <TargetIndustries />

      {/* <VisaType />
      {listSmartFormState.isLoading ? (
        <div style={{ marginTop: 24 }}>
          <Loading />
        </div>
      ) : (
        <>
          {shouldShowContinue && (
            <div style={{ marginTop: 24 }}>
              <Paper style={{ padding: 24 }}>
                <ContentTitle
                  atitle="Continue you process"
                  title="Application Form is not finished yet."
                  subTitle="Smart form document"
                />
                <div style={{ marginTop: 16 }} />
                <ColorButton
                  variant="contained"
                  color="success"
                  onClick={handleClickContinue}
                >
                  Continue process..
                </ColorButton>{" "}
              </Paper>
            </div>
          )}
          {shouldShowVisaType && <VisaType />}
          {hasSmartFormComplete && <VisaStatusCard />}
          <VisaStatusCard />
        </>
      )} */}
      {/* <VisaStatusCard /> */}
      {/* <TypeOfSmartVisa /> */}
    </div>
  );
}

export default InformationTab;
